/**
 * @name DownloadFileService
 * @description Servicio para realizar descargas de forma directa
 * @author Alexis Becerra
 */

const download = (file) => {
  let extention = file.split('.').pop();
  let name = file.split('/').pop();
  let fileName = name.split('.');

  fetch(file)
    .then((resp) => resp.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      // the filename you want
      a.download = (`${fileName[0]}.${extention}`);
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(() => { });
};

export const DownloadFileService = {
  download
};